import { oktaGet } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';
import { useQuery } from 'react-query';
import { CreditUtilizationResponse } from '@/app/features/DebtorPortal/Widgets/CreditUtilization/CreditUtilization.types';
export interface GetCreditUtilizationRequest {
  debtorId: number;
  companyId: number;
  searchTerm?: string;
}

export interface UseCreditUtilizationOptions {
  enabled?: boolean;
}

export const getCreditUtilization = async ({
  debtorId,
  searchTerm,
}: GetCreditUtilizationRequest): Promise<CreditUtilizationResponse> => {
  const route = ApiRoutes.DebtorCreditUtilization.replace(
    ':debtorId',
    String(debtorId),
  );

  const requestConfig = {
    params: {
      ...(searchTerm ? { searchTerm } : {}),
    },
  };

  const response = await oktaGet<CreditUtilizationResponse>(
    route,
    requestConfig,
  );

  return response.data;
};

export const useCreditUtilization = (
  request: GetCreditUtilizationRequest,
  options: UseCreditUtilizationOptions = {},
) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: [
      'creditUtilization',
      request.debtorId,
      request.companyId,
      request.searchTerm,
    ],
    enabled: enabled && !!request.debtorId && !!request.companyId,
    keepPreviousData: true,
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 403) {
        return false;
      }
      //prevents loop from 403 failures
      return failureCount < 3;
    },
    queryFn: async (): Promise<CreditUtilizationResponse> => {
      try {
        return await getCreditUtilization(request);
      } catch (error: any) {
        if (error?.response?.status === 403) {
          return {
            usagePercentage: 0,
            clients: [],
          };
        }
        throw error;
      }
    },
  });
};